/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/

/* istanbul ignore file */
import AccountsIcon from './accounts/AccountsIcon';
import DepositIcon from './deposit/DepositIcon';
import ZelleIcon from './zelle/ZelleIcon';
import TransferIcon from './transfer/TransferIcon';
import MenuIcon from './menu/MenuIcon';
import MessagesIcon from './messages/MessagesIcon';
export default {
  'accounts-home': AccountsIcon,
  'deposit-home': DepositIcon,
  'zelle-home': ZelleIcon,
  'transfer-home': TransferIcon,
  'messaging-home': MessagesIcon,
  'menu': MenuIcon
};